import React, { useEffect, useState } from "react";
import { DiscreteColorLegend } from "react-vis";
import Table from "./landingTable";
import "reactjs-popup/dist/index.css";
import "../../styling/sidebar.css";
import {
  Container,
  Row,
  Col,
  Popover,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useHistory } from "react-router-dom";
import AuthService from "../../services/auth";
import UserService from "../../services/user-service";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import "./styling/style.css";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import * as Scroll from "react-scroll";
import ReactGA from "react-ga";
import Sidebar from "../Sidebar";
import { ReactComponent as CrossButton } from "../../assets/cross.svg";
import { ReactComponent as AddIcon } from "../../assets/addicon.svg";
import CardView from "../CardView";
import { DateRangePicker } from "rsuite";
import Mode from "../Mode";
import ProfitGraph from "../Charts/ProfitGraph";
import { ReactComponent as CancelIcon } from "../../assets/Icon/close_circled_icon.svg";

const cache = createCache({
  key: "css",
  prepend: false,
});

let change = 0;

const dateArrayNew = [
  "Thu Aug 04 2022",
  "Fri Aug 12 2022",
  "Tue Aug 16 2022",
  "Mon Sep 05 2022",
  "Tue Sep 06 2022",
  "Thu Sep 22 2022",
];

const filterGraphData = {
  "Cameron’s Jewelry Shop": {
    "Mon Sep 05 2022": ["2022-09-04T18:30:00.000Z", 19289.49],
    "Tue Sep 06 2022": ["2022-09-05T18:30:00.000Z", 20762.050000000003],
  },
  "The Antique Hunter": {
    "Thu Sep 22 2022": ["2022-09-21T18:30:00.000Z", 10149.119999999999],
    "Fri Aug 12 2022": ["2022-08-11T18:30:00.000Z", 5150.12],
    "Tue Aug 16 2022": ["2022-08-15T18:30:00.000Z", 10150.119999999999],
  },
  "Cameron’s Closet": {
    "Tue Sep 06 2022": ["2022-09-05T18:30:00.000Z", 34779.7],
    "Mon Sep 05 2022": ["2022-09-04T18:30:00.000Z", 33307.14],
  },
};

export const CloseIconWithTooltip = ({ className, ...props }: any) => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Exit
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <CancelIcon
        fill="#008737"
        className={`pointer-cursor ${className ? className : ""}`}
        {...props}
      />
    </OverlayTrigger>
  );
};

function Tutorial() {
  var scroll = Scroll.animateScroll;
  const history = useHistory();
  const [expGraphOp, setExpGraphOp] = useState(0);
  const [sidebar, setSidebar] = useState(false);
  const d = new Date();
  const [isReplay, setIsReplay] = useState(
    history.location.search.includes("replay=true")
  );

  const selectedMonthExpense = d.getMonth();
  const expense = [
    {
      name: "Cameron’s Jewelry Shop",
      amount: 500,
    },
    {
      name: "The Antique Hunter",
      amount: 0,
    },
    {
      name: "Cameron’s Closet",
      amount: 0,
    },
  ];
  ReactGA.pageview(window.location.pathname);
  const nrows = [
    "Cameron’s Jewelry Shop",
    "The Antique Hunter",
    "Cameron’s Closet",
  ];

  useEffect(() => {
    setIsReplay(
      history.location.search.includes("replay=true") ||
        history.location.pathname.includes("replay=true")
    );
  }, [history.location.search]);

  const eventTrackSkip = (category, action, label) => {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  };

  function componentMounted() {
    const currUser = AuthService.getCurrentUser();
    if (!currUser) {
      history.push("/auth/login");
    }
  }

  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [step4, setStep4] = useState(false);
  const [step5, setStep5] = useState(false);

  const handleClose = () => {
    setStep1(false);
    if (isReplay) history.push("/");
  };

  const showstep2 = () => {
    setStep1(false);
    setStep2(true);
    const div = document.getElementById("page-title-home");
    if (div)
      div.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
  };
  const showstep3 = () => {
    setStep2(false);
    setStep3(true);
    const element = document.getElementById("incomeStreams");
    if (element)
      element?.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  const showstep4 = () => {
    setStep3(false);
    setStep4(true);
    scroll.scrollToBottom();
  };

  const showstep5 = () => {
    setStep4(false);
    setStep5(true);
    scroll.scrollToBottom();
  };

  const skiptutorial = async (e) => {
    e.preventDefault();
    setStep1(false);
    try {
      UserService.tutorialDone(AuthService.getCurrentUser()).then(() => {
        eventTrackSkip("Skip Tutorial", "Skipped Tutorial", "Button");
        history.push("/");
      });
    } catch (e) {}
  };

  const popoverS2 = (
    <Popover
      style={{ marginLeft: 0 }}
      id="popover-basic"
      className="all-popover"
    >
      <Popover.Title
        as="h3"
        className="popover-title d-flex justify-content-between"
      >
        <span>Profit Analysis</span>
        {isReplay && <CloseIconWithTooltip onClick={handleClose} />}
      </Popover.Title>
      <Popover.Content className="popover-content">
        You can see the profits for your businesses updated in real time. You
        can toggle by different businesses and dates.
      </Popover.Content>
      <Button onClick={showstep3} className="popover-button">
        Next
      </Button>
    </Popover>
  );

  const popoverS3 = (
    <Popover
      style={{ marginLeft: 15, marginTop: 18 }}
      id="popover-basic2"
      className="all-popover"
    >
      <Popover.Title
        as="h3"
        className="popover-title d-flex justify-content-between"
      >
        <span>Income Table</span>
        {isReplay && <CloseIconWithTooltip onClick={handleClose} />}
      </Popover.Title>
      <Popover.Content className="popover-content">
        You manage all your businesses from this table or the left sidebar.
      </Popover.Content>
      <Button onClick={showstep4} className="popover-button">
        Next
      </Button>
    </Popover>
  );

  const popoverS4 = (
    <Popover
      style={{ marginLeft: 15, marginTop: 18 }}
      id="popover-basic2"
      className="all-popover"
    >
      <Popover.Title
        as="h3"
        className="popover-title d-flex justify-content-between"
      >
        <span>Sales Goals</span>
        {isReplay && <CloseIconWithTooltip onClick={handleClose} />}
      </Popover.Title>
      <Popover.Content className="popover-content">
        Set daily, weekly, monthly or yearly sales goals for your business(es)
        and monitor progress.
      </Popover.Content>
      <Button onClick={showstep5} className="popover-button">
        Next
      </Button>
    </Popover>
  );

  componentMounted();
  return (
    <>
      <CacheProvider value={cache}>
        <Container fluid>
          <Row>
            <Sidebar sidebar={sidebar} setSidebar={setSidebar} />
            <Col
              className={
                sidebar
                  ? `overview-section`
                  : `overview-section sidebar-collapse`
              }
            >
              <Row className="tutorial-wrapper">
                <Col>
                  <Row className="overview-section-heading">
                    <Col className="p-0">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="overview" id="page-title-home">
                          My Businesses
                        </div>
                        <div className="header-button">
                          <button
                            className="add-bussiness-button darkFont"
                            disabled
                          >
                            <AddIcon /> Add Business
                          </button>
                          <button
                            className="add-bussiness-button darkFont"
                            disabled
                          >
                            <AddIcon /> Calculate Pricing
                          </button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Modal id="modal-1" show={step1}>
                      <Modal.Header>
                        <Modal.Title>
                          <div className="d-flex justify-content-between w-100">
                            <span>Welcome to Sotira!</span>
                            {isReplay && (
                              <CloseIconWithTooltip onClick={handleClose} />
                            )}
                          </div>
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div>
                          This brief guide will walk you through how to use the
                          platform.
                        </div>
                      </Modal.Body>
                      <Modal.Footer className="skip">
                        <Button onClick={skiptutorial} className="skip-button">
                          {" "}
                          Skip{" "}
                        </Button>
                        <Button onClick={showstep2} className="modal-button">
                          {" "}
                          Start{" "}
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </Row>
                  <Row className="initial-summary">
                    <Col lg={8}>
                      <div
                        className={
                          sidebar
                            ? "summary-content-sidebar"
                            : "summary-content"
                        }
                      >
                        {
                          <p className="summary-message m-0">
                            Welcome back! Your sales are up{" "}
                            <span className="summary-text">75%</span> and your
                            expenses are down{" "}
                            <span className="summary-text">68%</span>. Keep up
                            the good work!
                          </p>
                        }
                        <CrossButton className="cross-icon" />
                      </div>
                    </Col>
                  </Row>
                  <Row className="graph-section">
                    <Col lg={3} className="source-container">
                      <div className="d-flex flex-column mt-4 pt-1">
                        <span className="graph-heading">Profit Graph</span>
                        <FormControl
                          sx={{ m: 1, width: 250, margin: 3 }}
                          defaultValue={0}
                          size="small"
                          className="m-0"
                        >
                          <OverlayTrigger
                            show={step2}
                            placement="right"
                            overlay={popoverS2}
                          >
                            <div style={{ width: "fit-content" }}>
                              <InputLabel
                                id="exp-source-option-label"
                                className="source-title"
                              >
                                All Businesses
                              </InputLabel>
                              <Select
                                labelId="exp-source-option-label"
                                id="exp-source-option"
                                label="Source"
                                disabled
                                className="income-source"
                                sx={{
                                  color: "#48B7A7",
                                  fontWeight: 700,
                                  border: "red",
                                }}
                              >
                                <MenuItem key="all" value="0">
                                  All Businesses
                                </MenuItem>
                              </Select>
                            </div>
                          </OverlayTrigger>

                          <Box
                            sx={{
                              marginTop: 3,
                              marginBottom: 3,
                              width: 275,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <DateRangePicker
                              placeholder="Select Date"
                              className="dateRange"
                            />
                          </Box>
                          <div className="ml-2">
                            {change == 0 && (
                              <DiscreteColorLegend width={300} items={nrows} />
                            )}
                            {change == -1 && expGraphOp == 0 && (
                              <DiscreteColorLegend width={300} items={nrows} />
                            )}
                            {change == 1 && expGraphOp == 0 && (
                              <DiscreteColorLegend width={300} items={nrows} />
                            )}
                          </div>
                        </FormControl>
                      </div>
                    </Col>

                    <Col lg={9} className="profit-container">
                      <div className="graph-container">
                        <ProfitGraph
                          dateList={dateArrayNew}
                          allData={filterGraphData}
                          stream={-1}
                          color={"#000000"}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className={sidebar ? `card-row-sidebar` : `card-row`}>
                    <Col lg={4} className="cards-column p-0">
                      <CardView
                        cardType="Revenue"
                        data={expense}
                        selectedCardMonth={selectedMonthExpense}
                        loader={false}
                        nrows={nrows}
                        summary={`None of your businesses made sales in ${new Date().toLocaleString(
                          "default",
                          { month: "long" }
                        )}`}
                        checkSalesData={true}
                        sideBar={sidebar}
                        calculateAmount={() => {}}
                        isTutorial
                        btnText={
                          <OverlayTrigger
                            show={step4}
                            placement="right"
                            overlay={popoverS4}
                          >
                            <span>View sales goals</span>
                          </OverlayTrigger>
                        }
                      />
                    </Col>
                    <Col lg={4} className="pl-xl-0 cards-column p-0">
                      <CardView
                        cardType="Profit"
                        data={expense}
                        selectedCardMonth={selectedMonthExpense}
                        loader={false}
                        nrows={nrows}
                        summary={`None of your businesses made sales in ${new Date().toLocaleString(
                          "default",
                          { month: "long" }
                        )}`}
                        checkSalesData={false}
                        sideBar={sidebar}
                        calculateAmount={() => {}}
                        isTutorial
                      />
                    </Col>

                    <Col lg={4} className="pr-xl-0 cards-column p-0">
                      <CardView
                        cardType="Expenses"
                        data={expense}
                        selectedCardMonth={selectedMonthExpense}
                        loader={false}
                        nrows={nrows}
                        summary={`User had the most expenses in ${new Date().toLocaleString(
                          "default",
                          { month: "long" }
                        )}`}
                        checkSalesData={false}
                        sideBar={sidebar}
                        calculateAmount={() => {}}
                        isTutorial
                      />
                    </Col>
                  </Row>

                  <Row className={sidebar ? "table-row-sidebar" : ""}>
                    <Col className="table-content">
                      <div
                        className={
                          sidebar ? `landing-table-sidebar` : `landing-table`
                        }
                      >
                        <div className="income-streams-table">
                          <div
                            className="table-main-header d-flex justify-content-between"
                            id="table-main-header"
                          >
                            <div className="d-flex mb-4">
                              <OverlayTrigger
                                show={step3}
                                placement="right"
                                overlay={popoverS3}
                              >
                                <span
                                  className="stream-title"
                                  id="incomeStreams"
                                >
                                  All Businesses{" "}
                                </span>
                              </OverlayTrigger>
                            </div>
                          </div>

                          {!step5 && <Table />}
                          {step5 && <Table step={true} isReplay={isReplay} />}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </CacheProvider>
      <Mode />
    </>
  );
}

export default Tutorial;
